import * as React from 'react';

import { SimpleSticky } from '../SimpleSticky';
import { useOldStickyProps } from './useOldStickyProps';

export interface IOldStickyProps {
  zIndex?: number;
  bottom?: string | number;
  top?: string | number;
  onBottomStuck?: (isIntersecting: boolean) => void;
  onTopStuck?: (isIntersecting: boolean) => void;
  testId?: string;
}

export const OldSticky: React.FC<React.PropsWithChildren<IOldStickyProps>> = props => {
  const { onBottomStuck, onTopStuck, top, bottom, zIndex, children, testId = 'oldSticky' } = props;
  const { sentinelRef } = useOldStickyProps({ children, onBottomStuck, onTopStuck });

  return (
    <SimpleSticky ref={sentinelRef} zIndex={zIndex} bottom={bottom} top={top} testId={testId}>
      {children}
    </SimpleSticky>
  );
};

OldSticky.displayName = 'OldSticky';
